import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/route-guards'
import { KuraEditForm } from '@/components/kura-edit-form'

export const Route = createFileRoute('/_authenticated/kura/$kuraId/edit')({
  beforeLoad: requireAuth,
  component: KuraEditPage,
})

function KuraEditPage() {
  const { kuraId } = Route.useParams()
  
  return (
    <div className="w-full mx-auto p-4 pt-6 pb-0">
      <div className="w-full mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold tracking-tight">Kura Düzenle</h1>
          <p className="text-gray-600 mt-1">Kura bilgilerini güncelleyin</p>
        </div>
        <div>
          <KuraEditForm kuraId={kuraId} />
        </div>
      </div>
    </div>
  )
}